import React, { useState } from "react";
// 12 Jun 2025
import { useGetUserActionsQuery } from '@/features/userActions/userActionsApiSlice'
import { useGetTrailsQuery } from '@/features/trails/trailsApiSlice'

// 22 Jun 2025
import { useGetUserConversationsQuery } from '@/features/userConversations/userConversationsApiSlice'
import { useGetUserCalendarEventsQuery } from "@/features/calendarEvents/calendarEventsApiSlice";
import { useGetUserMeetingPrepsQuery } from "@/features/userMeetingPreps/userMeetingPrepsApiSlice";
import { useGetContactsQuery } from "@/pages/admin/contacts/contactsApiSlice"

import {
  PlusIcon,
  MinusIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline"

import { 
  ClockIcon, 
  CalendarDaysIcon, 
  UserGroupIcon,
  ArrowPathIcon,
  DocumentTextIcon,
  ArrowTrendingUpIcon,
  ShareIcon 
} from "@heroicons/react/24/solid"

// 21 Jun 2025
import EtWabConversationIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabConversationIcon1SVGComp" 
import EtWabActionIcon1SVGComp from "@/assets/img/icons/svgComp/EtWabActionIcon1SVGComp" 

import EtFollowUpActionCard from '@/components/actions/EtFollowUpActionCard' // 22 Jun 2025
import EtMeetingCard from "@/components/meetings/EtMeetingCard";

// 22 Jun 2025 
import EtModalCreateFollowUpUserAction from "@/components/common/modal/EtModalCreateFollowUpUserAction"

import moment from "moment";

const EtTrinityAddActionItems = ({ userId, onClose }) => {

  // First Created - 19 May 2025
  // Author - Atul Pandey
  // Purpose - Add follow up actions from prior meetings or non meeting mission actions
  // Updated - 21 Jun 2025 - Added the main logic
  // Updated - 23 Jun 2025 - Added calendarMeetingId for matching actions with linkedMeetings
  

  // 1a-  State variables
  const [selectedTrail, setSelectedTrail] = useState("all");
  const [selectedTimeChip, setSelectedTimeChip] = useState("today");// 21 Jun 2025
  const [selectedSubTab, setSelectedSubTab] = useState("actions"); // 21 Jun 2025 "conversations" or "actions"
  const [showFollowUpModal, setShowFollowUpModal] = useState(false); // 22 Jun 2025


  // 1b - Time boundaries - 21 Jun 2025
  // const now = moment();
  // const startOfToday = moment().startOf("day");
  // const startOfWeek = moment().startOf("week");
  // const startOfMonth = moment().startOf("month");
  // const startOfQuarter = moment().startOf("quarter");
  // const startOfYear = moment().startOf("year");

  // 22 Jun 2025
  const now = moment();
  const startOfToday = moment().startOf("day");
  const endOfToday = moment().endOf("day");

  // const startOfWeek = moment().startOf("week"); // Monday 00:00
  const startOfWeek = moment().isoWeekday(1).startOf("day"); // Monday of current week
  const endOfWeek = endOfToday; // ✅ Cap at today to avoid future meetings

  const startOfMonth = moment().startOf("month"); // 1st of month
  const endOfMonth = moment().isSame(now, 'month') ? endOfToday : moment().endOf("month");

  const startOfQuarter = moment().startOf("quarter");
  const endOfQuarter = moment().isSame(now, 'quarter') ? endOfToday : moment().endOf("quarter");

  const startOfYear = moment().startOf("year");
  const endOfYear = moment().isSame(now, 'year') ? endOfToday : moment().endOf("year");


  // 1c - Add Sub Tab List
  const subTabs = [
  {
    label: "Conversations",
    value: "conversations",
    icon: EtWabConversationIcon1SVGComp,
  },
  {
    label: "Actions",
    value: "actions",
    icon: EtWabActionIcon1SVGComp,
  },
];
  
  // 2a - Fetch Data
  const { data: userActionsData, refetch: refetchUserActions } = useGetUserActionsQuery();
  const { data: trailsData } = useGetTrailsQuery();

  
  const { data: userConversationsData } = useGetUserConversationsQuery(); // 22 Jun 2025
  const { data: calendarEventsData } = useGetUserCalendarEventsQuery();   // 22 Jun 2025

  const { data: userMeetingPrepsData, isLoading: isLoadingMeetingPreps } = useGetUserMeetingPrepsQuery();
  const { data: contactsData } = useGetContactsQuery();// 12 Jun 2025

  // 2️b -  Extract Data
  const extractEntitiesFromAdapter = (dataAdapter) => {
    if (!dataAdapter || !dataAdapter.ids || !dataAdapter.entities) return [];
    return dataAdapter.ids.map((id) => dataAdapter.entities[id]);
  };

  const allActions = extractEntitiesFromAdapter(userActionsData);
  const allTrails = extractEntitiesFromAdapter(trailsData);
  const allUserConversations = extractEntitiesFromAdapter(userConversationsData); // 22 Jun 2025
  // const allMeetings = extractEntitiesFromAdapter(calendarEventsData);             // 22 Jun 2025
  const allMeetings = calendarEventsData?.filter(item => item?.isAllDay === false && item?.userId === userId);             // 22 Jun 2025

  const userMeetingPrepsAll = extractEntitiesFromAdapter(userMeetingPrepsData); // 22 Jun 2025
  const relevantContacts = extractEntitiesFromAdapter(contactsData) // 22 Jun 2025

  const userMeetingPreps = userMeetingPrepsAll?.filter(item => !item?.calendarMeetingId?.isAllDay)

  // console.log('allActions', allActions)
  // console.log('allTrails', allTrails)
  // console.log('allConversations', allUserConversations)
  
  // console.log('calendarEvents', calendarEventsData)
  // console.log('allMeetings', allMeetings)

  // 3️⃣ Filter all actions for this user (no longer limited to completed ones)
  const userActions = allActions?.filter(action =>
    action?.userId?._id === userId
  );

  // 3b️ Time Chip Filter
  const timeFilteredActions = userActions?.filter(action => {
    // const completedDate = moment(action.updatedAt || action.completedAt || action.completeBy);
    const createdDate = moment(action.createdAt);
    switch (selectedTimeChip) {
      case "today":
        return createdDate.isSame(startOfToday, "day");
      case "week":
        return createdDate.isSameOrAfter(startOfWeek);
      case "month":
        return createdDate.isSameOrAfter(startOfMonth);
      case "quarter":
        return createdDate.isSameOrAfter(startOfQuarter);
      case "year":
        return createdDate.isSameOrAfter(startOfYear);
      default:
        return true;
    }
  });

  const usedTrailNames = Array.from(new Set(timeFilteredActions?.map(a => a?.trailId?.trailName)));
;

  const filteredActions = selectedTrail === "all"
  ? timeFilteredActions
  : timeFilteredActions?.filter(a => a?.trailId?.trailName === selectedTrail);

  // 4 - Get Linked Meeting For each action - 22 Jun 2025, Updated 23 Jun 2025
  const getLinkedMeetingForAction = (action) => {
    const { sourceConversation, calendarMeetingId } = action || {}; // 23 Jun 2025 - added calendarMeetingId
    
    
    // 23 Jun 2025 - ✅ First try direct link via calendarMeetingId
    if (calendarMeetingId) {
      const directMeeting = allMeetings?.find(meeting => meeting._id === calendarMeetingId);
      if (directMeeting) return directMeeting;
    }
    
    // ✅ Fallback: Try sourceConversation path
    const sourceConvId = sourceConversation?.sourceConversationId;
    const sourceNoteId = sourceConversation?.sourceNoteId;
    if (!sourceConvId || !sourceNoteId) return null;

    const conversation = allUserConversations?.find(conv => conv._id === sourceConvId);
    if (!conversation) return null;

    
    const allNotes = [
      ...(conversation.userConversationAllNotes || []),
      ...(conversation.userConversationContactNotes || []),
    ];

    const matchedNote = allNotes?.find(note => note._id === sourceNoteId);
    // if(sourceConvId === '6849a3e8ab8b59a348ac5a0e') {
    //   console.log('userConversation Record id', sourceConvId)
    //   console.log('userConversation Note Id', sourceNoteId)
    //   console.log('userConversation', conversation)
    //   console.log('allNotes', allNotes)
    //   console.log('matchedNote', matchedNote)
    // }


    if (!matchedNote?.calendarMeetingId) return null;


    return allMeetings?.find(meeting => meeting._id === matchedNote?.calendarMeetingId) || null;
  };

  // 5 - Filter Meetings based on time chip
  // const filteredMeetings = allMeetings?.filter(meeting => {
  //   if (meeting.isAllDay) return false;

  //   const meetingStart = moment(meeting.startTime);

  //   switch (selectedTimeChip) {
  //     case "today":
  //       return meetingStart.isSame(startOfToday, "day");
  //     case "week":
  //       return meetingStart.isSameOrAfter(startOfWeek);
  //     case "month":
  //       return meetingStart.isSameOrAfter(startOfMonth);
  //     case "quarter":
  //       return meetingStart.isSameOrAfter(startOfQuarter);
  //     case "year":
  //       return meetingStart.isSameOrAfter(startOfYear);
  //     default:
  //       return true;
  //   }
  // });

  const filteredMeetings = allMeetings?.filter(meeting => {
  if (meeting.isAllDay) return false;

  const meetingStart = moment(meeting.startTime);

  switch (selectedTimeChip) {
    case "today":
      return meetingStart.isBetween(startOfToday, endOfToday, null, "[]");
    case "week":
      return meetingStart.isBetween(startOfWeek, endOfWeek, null, "[]");
    case "month":
      return meetingStart.isBetween(startOfMonth, endOfToday, null, "[]");
    case "quarter":
      return meetingStart.isBetween(startOfQuarter, endOfToday, null, "[]");
    case "year":
      return meetingStart.isBetween(startOfYear, endOfToday, null, "[]");
    default:
      return true;
  }
});




  return (
    <div className="p-4 w-full max-w-6xl mx-auto">
      <div className="flex justify-between items-center">

        <div className="flex justify-start items-center">
            <p className="text-lg font-bold text-gray-800 mx-2 px-2">Add Follow Up Actions</p>
            <div className="flex justify-start">
            <button
              onClick={() => setShowFollowUpModal(true)}
              className="bg-lime-600 hover:bg-lime-700 text-white font-semibold p-2 rounded shadow"
            >
              <PlusIcon className="h-5 w-5"/>
            </button>
          </div>
        </div>
           
          {/* Close */}
        <button onClick={onClose} className="mx-2 px-2 mb-2 text-sm text-blue-600 underline">
          Close
        </button>
      </div>
    
      {/* Trail Filter */}
      <div className="m-1 p-1">
      <div className="my-2 py-2 flex justify-center items-center space-x-2 border-b border-t bg-orange-50">
        <div className="flex items-center">
          <ArrowTrendingUpIcon className="w-6 h-6 text-orange-600" />
          <p className="mx-1 px-1 text-lg font-bold text-orange-600">Trail:</p>
          <select
            value={selectedTrail}
            onChange={(e) => setSelectedTrail(e.target.value)}
            className="text-lg font-bold rounded border border-gray-300 px-2 py-1"
          >
            <option value="all">All Trails</option>
            {allTrails
              ?.filter(trail => usedTrailNames.includes(trail.trailName))
              ?.map(trail => (
                <option key={trail._id} value={trail.trailName}>
                  {trail.trailName}
                </option>
            ))}
          </select>
        </div>

        {/* Count Badge - dynamically show actions or meetings */}
        <div className="flex justify-center items-center">
          <span className="text-lg text-gray-700 mx-1 px-1">You</span>

          <span className="text-lg text-gray-700 mr-1 pr-1">
            {selectedSubTab === "actions"
              ? "added"
              : selectedTimeChip === "today"
              ? "have"
              : "had"}
          </span>

          <div
            className={`rounded-full bg-orange-600 text-white flex justify-center items-center text-lg font-bold ${
              (selectedSubTab === "actions" ? filteredActions?.length : filteredMeetings?.length) > 99
                ? "px-3 py-1 min-w-[3rem]"
                : "w-8 h-8"
            }`}
          >
            {selectedSubTab === "actions" ? filteredActions?.length || 0 : filteredMeetings?.length || 0}
          </div>

          <span className="text-lg text-gray-700 mx-1 px-1">
            <span
              className={`font-bold ${
                ["today", "week", "month", "quarter", "year"].includes(selectedTimeChip)
                  ? "text-orange-800"
                  : ""
              }`}
            >
              {selectedSubTab === "actions"
                ? filteredActions?.length === 1
                  ? "action"
                  : "actions"
                : filteredMeetings?.length === 1
                ? "meeting"
                : "meetings"}
            </span>{" "}
            <span className="font-bold">
              {selectedTimeChip === "today"
                ? "today"
                : selectedTimeChip === "week"
                ? "this week"
                : selectedTimeChip === "month"
                ? "this month"
                : selectedTimeChip === "quarter"
                ? "this quarter"
                : "this year"}
            </span>
            !
          </span>
        </div>



      </div>
      </div>

      {/* Time Chips */}
      <div className="flex justify-center items-center gap-2 my-3">
        {["today", "week", "month", "quarter", "year"].map(chip => (
          <button
            key={chip}
            onClick={() => setSelectedTimeChip(chip)}
            className={`px-3 py-1 text-sm font-semibold rounded-full border ${
              selectedTimeChip === chip
                ? "bg-orange-600 text-white border-orange-600"
                : "bg-white text-gray-700 border-gray-300"
            }`}
          >
            {chip === "today" ? "Today" :
            chip === "week" ? "This Week" :
            chip === "month" ? "This Month" :
            chip === "quarter" ? "This Quarter" :
            "This Year"}
          </button>
        ))}
      </div>

      {/* Sub Tabs */}
      <div className="flex justify-start items-center gap-4 mx-2 my-4 pt-4 border-t">
        {subTabs.map(({ label, value, icon: IconComp }) => (
          <div
            key={value}
            onClick={() => setSelectedSubTab(value)}
            className={`flex items-center space-x-2 px-2 rounded-full border cursor-pointer shadow-md ${
              selectedSubTab === value
                // ? "bg-orange-600 text-white border-orange-600"
                ? "text-white bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:bg-gradient-to-r hover:from-orange-400 hover:via-orange-600 hover:to-black cursor-pointer shadow-md"
                : "bg-white text-gray-700 border-gray-300"
            }`}
          >
            <IconComp className="h-8 w-8" />
            <span className="text-sm font-semibold">{label}</span>
          </div>
        ))}
      </div>

      {/* Action List */}
      <div className="max-h-[400px] overflow-y-auto ">

        {selectedSubTab === "actions" && filteredActions?.length > 0 && (
          filteredActions
            ?.slice()
            ?.sort((a, b) => new Date(b.completeBy) - new Date(a.completeBy))
            ?.map((action, index) => {
              const linkedMeeting = getLinkedMeetingForAction(action); // ⬅️ Define this function below
              // console.log('action for the action card', action)
              // console.log('linkedMeeting for action', linkedMeeting)
              return (
                <EtFollowUpActionCard
                  key={action._id}
                  action={action}
                  actionIndex={index}
                  linkedMeeting={linkedMeeting} // ⬅️ Just pass meeting info
                  refetchUserActions={refetchUserActions}
                  showEdit={false}
                />
              );
            })
        )}

        {selectedSubTab === "actions" && filteredActions?.length === 0 && (
          <p className="text-sm italic text-gray-500 mt-4">
            No follow up actions found for{" "}
            {selectedTimeChip === "today"
              ? "today"
              : selectedTimeChip === "week"
              ? "this week"
              : selectedTimeChip === "month"
              ? "this month"
              : selectedTimeChip === "quarter"
              ? "this quarter"
              : "this year"}
            .
          </p>
        )}

        {selectedSubTab === "conversations" && filteredMeetings?.length >0 && (
          <div className="mt-2">
            {filteredMeetings
            .slice()
            .sort((a, b) => new Date(b.startTime) - new Date(a.startTime)) // ✅ Descending
            ?.map((event, index) => (
              <EtMeetingCard
                key={event._id}
                event={event}
                index={index}
                activeTab="conversations"
                matchingPrep={userMeetingPreps?.find(prep => prep?.calendarMeetingId?._id === event._id)}
                relevantContacts={relevantContacts}
                // userEmail=""
              />
            ))}
          </div> 
        )}
       
        {selectedSubTab === "conversations" && filteredMeetings?.length === 0 && (
          <p className="text-sm italic text-gray-500 mt-4">
            No meetings found for{" "}
            {selectedTimeChip === "today"
              ? "today"
              : selectedTimeChip === "week"
              ? "this week"
              : selectedTimeChip === "month"
              ? "this month"
              : selectedTimeChip === "quarter"
              ? "this quarter"
              : "this year"}
            .
          </p>
        )}

      </div>

      {/* Modal - Create Follow up Action */}
      <EtModalCreateFollowUpUserAction
          showModal={showFollowUpModal}
          onClose={() => setShowFollowUpModal(false)}
          refetchUserActions={refetchUserActions}
      />

      
    </div>
  );
};

export default EtTrinityAddActionItems;